import React from 'react';
import s from './InstagramPost.module.css';
import IconLogo from '../icons/IconLogo';
import { ScriptData } from '../../types/scriptTypes';
import IconIstagramLike from '../icons/IconIstagramLike';
import IconIstagramComment from '../icons/IconIstagramComment';
import IconIstagramShare from '../icons/IconIstagramShare';
import IconIstagramSave from '../icons/IconIstagramSave';
import AvatarComponent from '../avatar/AvatarComponent';

type InstagramPostProps = {
    avatar: string | null;
    name: string | null;
    text: ScriptData | null;
    image: {
        id: string;
        url: string;
    } | null;
    isPosted: boolean;
};

const InstagramPost = ({ avatar, name, text, image, isPosted }: InstagramPostProps) => {
    function getShortTextFromHtml(html: string, maxLen = 60): string {
        const plainText = html.replace(/<[^>]*>/g, '');
        if (plainText.length > maxLen) {
            return plainText.slice(0, maxLen - 3) + '...';
        }
        return plainText;
    }

    return (
        <div className={s.container + ' ' + (isPosted ? s.posted : '')}>
            <div className={s.header}>
                <AvatarComponent avatarUrl={avatar ?? ''} userName={name || ''} />
                <span className={s.username}>{name}</span>
                <span className={s.menu}>⋯</span>
            </div>
            <img
                src={image?.url || 'https://via.placeholder.com/340x220'}
                className={s.image}
                alt="post"
            />
            <div className={s.actions}>
                <IconIstagramLike />
                <IconIstagramComment />
                <IconIstagramShare />
                <IconIstagramSave />
            </div>
            <div className={s.likes}>1.1M Likes</div>
            <div className={s.caption}>
                <span className={s.username}>{name}</span> {getShortTextFromHtml(text?.body || '')}
            </div>
            <div className={s.comments}>View all 102 comments</div>
        </div>
    );
};

export default InstagramPost;
